import React from 'react';

interface ErrorFallbackProps {
  error: Error;
  resetError: () => void;
}

export function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  return (
    <div className="error-fallback">
      <div className="error-fallback__container">
        <h2 className="error-fallback__title">Sorry, something went wrong</h2>
        <p className="error-fallback__message">
          We encountered an unexpected error. Please try refreshing the page or contact support if the problem persists.
        </p>
        <button
          className="error-fallback__button"
          onClick={resetError}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
